<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-flex align-items-center justify-content-between">
        <h4 class="mb-0">Admin Dashboard</h4>
        <div class="page-title-right">
          <ol class="breadcrumb m-0">
            <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboard</a></li>
            <li class="breadcrumb-item active">Admin</li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <!-- Stats Cards -->
  <div class="row">
    <div class="col-md-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="float-end mt-2">
            <div id="total-clients-chart"></div>
          </div>
          <div>
            <h4 class="mb-1 mt-1"><span data-plugin="counterup">{{ totalClients }}</span></h4>
            <p class="text-muted mb-0">Total Clients</p>
          </div>
          <p class="text-muted mt-3 mb-0"><span class="text-success me-1"><i class="mdi mdi-arrow-up-bold"></i> 2.5%</span> Since last month
          </p>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="float-end mt-2">
            <div id="total-vms-chart"></div>
          </div>
          <div>
            <h4 class="mb-1 mt-1"><span data-plugin="counterup">{{ totalVMs }}</span></h4>
            <p class="text-muted mb-0">Total VMs</p>
          </div>
          <p class="text-muted mt-3 mb-0"><span class="text-success me-1"><i class="mdi mdi-arrow-up-bold"></i> 3.2%</span> Since last month
          </p>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="float-end mt-2">
            <div id="running-vms-chart"></div>
          </div>
          <div>
            <h4 class="mb-1 mt-1"><span data-plugin="counterup">{{ runningVMs }}</span></h4>
            <p class="text-muted mb-0">Running VMs</p>
          </div>
          <p class="text-muted mt-3 mb-0"><span class="text-success me-1"><i class="mdi mdi-arrow-up-bold"></i> 5.1%</span> Since last month
          </p>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="float-end mt-2">
            <div id="stopped-vms-chart"></div>
          </div>
          <div>
            <h4 class="mb-1 mt-1"><span data-plugin="counterup">{{ stoppedVMs }}</span></h4>
            <p class="text-muted mb-0">Stopped VMs</p>
          </div>
          <p class="text-muted mt-3 mb-0"><span class="text-danger me-1"><i class="mdi mdi-arrow-down-bold"></i> 1.2%</span> Since last month
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h4 class="card-title">Management Actions</h4>
            <div>
              <button type="button" class="btn btn-primary waves-effect waves-light me-2" (click)="onAddClient()">
                <i class="mdi mdi-plus me-1"></i> Add Client
              </button>
              <button type="button" class="btn btn-success waves-effect waves-light" (click)="onAddVM()">
                <i class="mdi mdi-plus me-1"></i> Add VM
              </button>
              <button type="button" class="btn btn-outline-secondary waves-effect waves-light ms-2" (click)="refreshData()">
                <i class="mdi mdi-refresh me-1"></i> Refresh
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Clients and VMs Tables -->
  <div class="row">
    <div class="col-lg-6">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-4">Recent Clients</h4>
          <div class="table-responsive">
            <table class="table table-centered table-nowrap mb-0">
              <thead class="table-light">
                <tr>
                  <th>Client</th>
                  <th>Company</th>
                  <th>Status</th>
                  <th>VMs</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let client of clients">
                  <td>
                    <h5 class="font-size-14 mb-1">{{ client.name }}</h5>
                    <p class="text-muted mb-0">{{ client.email }}</p>
                  </td>
                  <td>{{ client.company }}</td>
                  <td>
                    <span class="badge" [ngClass]="{
                      'bg-success': client.status === 'active',
                      'bg-warning': client.status === 'inactive',
                      'bg-danger': client.status === 'suspended'
                    }">{{ client.status }}</span>
                  </td>
                  <td>{{ client.vms.length }}</td>
                  <td>
                    <button type="button" class="btn btn-primary btn-sm waves-effect waves-light" (click)="onViewClient(client.id)">
                      View
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-6">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-4">Recent VMs</h4>
          <div class="table-responsive">
            <table class="table table-centered table-nowrap mb-0">
              <thead class="table-light">
                <tr>
                  <th>VM Name</th>
                  <th>Node</th>
                  <th>Status</th>
                  <th>IP Address</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let vm of vms">
                  <td>
                    <h5 class="font-size-14 mb-1">{{ vm.name }}</h5>
                    <p class="text-muted mb-0">{{ vm.id }}</p>
                  </td>
                  <td>{{ vm.node }}</td>
                  <td>
                    <span class="badge" [ngClass]="getVMStatusClass(vm.status)">{{ vm.status }}</span>
                  </td>
                  <td>{{ vm.ipAddress }}</td>
                  <td>
                    <button type="button" class="btn btn-primary btn-sm waves-effect waves-light" (click)="onViewVM(vm.id)">
                      View
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Cluster Status -->
  <div class="row" *ngIf="clusterStatus">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-4">Cluster Status</h4>
          <div class="row">
            <div class="col-md-3">
              <div class="text-center">
                <h5 class="font-size-14 mb-2">Cluster Name</h5>
                <p class="text-muted mb-0">{{ clusterStatus.name }}</p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="text-center">
                <h5 class="font-size-14 mb-2">Version</h5>
                <p class="text-muted mb-0">{{ clusterStatus.version }}</p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="text-center">
                <h5 class="font-size-14 mb-2">Nodes</h5>
                <p class="text-muted mb-0">{{ clusterStatus.nodes }}</p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="text-center">
                <h5 class="font-size-14 mb-2">Quorate</h5>
                <p class="text-muted mb-0">{{ clusterStatus.quorate ? 'Yes' : 'No' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Nodes -->
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-4">Nodes</h4>
          <div class="table-responsive">
            <table class="table table-centered table-nowrap mb-0">
              <thead class="table-light">
                <tr>
                  <th>Node</th>
                  <th>Status</th>
                  <th>CPU</th>
                  <th>Memory</th>
                  <th>Uptime</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let node of nodes">
                  <td>
                    <h5 class="font-size-14 mb-1">{{ node.node }}</h5>
                  </td>
                  <td>
                    <span class="badge" [ngClass]="{
                      'bg-success': node.status === 'online',
                      'bg-danger': node.status === 'offline'
                    }">{{ node.status }}</span>
                  </td>
                  <td>{{ (node.cpu * 100).toFixed(1) }}%</td>
                  <td>{{ (node.memory / 1024 / 1024 / 1024).toFixed(1) }} GB</td>
                  <td>{{ formatUptime(node.uptime) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>